module.exports = __webpack_public_path__ + "img/easy.0a708905.png";